<template>
	<div
		class="cookies"
		v-if="display"
	>
		<div class="cookies__container">
            <span v-html="info.pl.description"></span>
			<a
				href="#"
				@click.prevent="closeCookies"
			><strong v-html="info.pl.accept"></strong></a>
		</div>
	</div>
</template>

<script>
// Remember to type `npm i vue-cookies`
// and put it into main.js `import VueCookies from 'vue-cookies', Vue.use(VueCookies)`
export default {
	data() {
		return {
			display: true,
			info: {
				pl: {
					accept: 'Akceptuję [x]',
					description: 'Strona przechowuje oraz uzyskuje dostęp do informacji już przechowywanej w urządzeniu użytkownika wykorzystując mechanizm plików Cookies. Akceptacja lub brak zgody na wykorzystywanie plików Cookies odbywa się za pomocą ustawień przeglądarki. Więcej informacji znajdziesz tutaj: Polityka prywatności.  '
				}
			}
		}
	},
	created() {
		if (this.$cookies.get('cookiesAgree') == 'set') {
			this.display = false
		}
	},
	methods: {
		closeCookies(){
			if (this.$cookies.get('cookiesAgree') != 'set') {
				this.$cookies.set('cookiesAgree', 'set', 60 * 60 * 24 * 30)
				this.display = false
			}
		}
	}
}
</script>

<style lang="scss">
.cookies{
	width: 100%;
	background-color: #1A2C70;
	position: fixed;
	bottom: 0;
	color: #fff;
	padding: 10px;
	z-index: 999;
	&__container{
		max-width: 1400px;
		width: 100%;
		margin: 0 auto;
	}
	a{
		color: #fff;
		font-size: 14px;
	}
	span{
		font-size: 14px;
	}
}
</style>
